import React from 'react';
import ScreeningData from '../../ScreeningData';

/**
 * Deployed Hearts > Patients
 *
 * Lists patients sourced from the HCW mobile app (BloodCardEncounter flow).
 * Reuses the All Members table component but forces the backend query to
 * filter by `dataSource=hcw_mobile`, so this page only shows mobile-origin
 * patients.
 */
const OnDemandPatients = () => (
  <ScreeningData
    forcedDataSource="hcw_mobile"
    pageTitleOverride="Deployed Hearts Patients"
  />
);

export default OnDemandPatients;
